import script from "./patientInfoBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./patientInfoBox.vue?vue&type=script&setup=true&lang=ts"

import "./patientInfoBox.vue?vue&type=style&index=0&id=ae8794ec&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae8794ec"]])

export default __exports__